export const actionType = {
  GET_PAGE_DATA_REQUEST:  'GET_PAGE_DATA_REQUEST',
  GET_PAGE_DATA_RECEIVED:  'GET_PAGE_DATA_RECEIVED',
  SAVE_SEARCH_OPTION :  "SAVE_SEARCH_OPTION",
  SEARCH_ARTICLE_REQUEST :  "SEARCH_ARTICLE_REQUEST",
  SEARCH_ARTICLE_SUCCESS :  "SEARCH_ARTICLE_SUCCESS",
  SEARCH_ARTICLE_FAILURE :  "SEARCH_ARTICLE_FAILURE",  
}

/**
 *  @getProductCategories method to get the product category for search page listing
 *  @input: null
 *  @output: json object of categories
 */
export const getPageDataAction = () => ({
  type: actionType.GET_PAGE_DATA_REQUEST
});


/**
 * @getArticleList method to get the article list as per search creteria
 * @input: Search Params like search key, search value, pagin offset
 * @output: Object of articles
 */
export const getArticleListAction = (searchParams, viewMore) => ({
  type: actionType.SEARCH_ARTICLE_REQUEST, payload:searchParams, viewMore:viewMore
})


/**
 * save search data in store
 * @input: search key and value
 */
export const saveSearchOptionAction = (searchParams) => ({
  type: actionType.SAVE_SEARCH_OPTION, payload:searchParams
})
